import { withRouter } from 'react-router-dom';
import _ from '../../../scripts/underscore';
import { useState } from 'react';

function PageHeader({data, children}) {
    const settingsInitialState = {
        headerTitleProperty: null,
        headerDescriptionProperty: null,
        headerRecordDescriptionProperty: null,
        headerIconProperty: null,
        shouldShowHeaderPostfixImage: null,
        headerPostfixImageUrl: null,
        shouldShowHeaderPostfixImageChem: null
    }

    const [ settings ] = useState(settingsInitialState);
    
    const getHeaderTitleText = function (item) {
        if (settings.headerTitleProperty) {
            return item[settings.headerTitleProperty];
        }
        else if (typeof item.pageHeaderTitle !== "undefined") {
            if (_.isFunction(item.pageHeaderTitle)) {
                return item.pageHeaderTitle();
            }
            return item.pageHeaderTitle;
        }

        return item.toString();
    };

    const getHeaderDescriptionText = function (item) {
        if (settings.headerDescriptionProperty) {
            return item[settings.headerDescriptionProperty];
        } else if (typeof item.pageHeaderDescription !== "undefined") {
            return item.pageHeaderDescription;
        }
    };

    const getHeaderRecordDescriptionText = function (item) {
        if (settings.headerRecordDescriptionProperty) {
            return item[settings.headerRecordDescriptionProperty];
        } else if (typeof item.pageHeaderRecordDescription !== "undefined") {
            return item.pageHeaderRecordDescription;
        }
    };

    const isHeaderIconSet = function (item) {
        if (settings.headerIconProperty) {
            return item[settings.headerIconProperty] != null;
        }
        else if (typeof item.pageHeaderIcon !== "undefined") {
            return item.pageHeaderIcon != null;
        }

        return false;
    }

    const getHeaderIconText = function (item) {
        if (settings.headerIconProperty) {
            return item[settings.headerIconProperty];
        }
        else if (typeof item.pageHeaderIcon !== "undefined") {
            return item.pageHeaderIcon;
        }

        return item.toString();
    }

    const shouldShowHeaderPostfixImage = function () {
        if (settings.shouldShowHeaderPostfixImage) {
            return settings.shouldShowHeaderPostfixImage();
        }
        
        return false;
    }

    const headerPostfixImageUrl = function () {
        return settings.headerPostfixImageUrl;
    };

    const shouldShowHeaderPostfixImageChem = function () {
        if (settings.shouldShowHeaderPostfixImageChem) {
            return settings.shouldShowHeaderPostfixImageChem();
        }

        return false;
    }

    const headerPostfixImageUrlChem = function () {
        return settings.headerPostfixImageUrlChem;
    };

    return (
        <div className="page-header clearfix">
            <div className="h1 site-primary-text-color">
                <h1 className="inline-block no-margin">
                    {!isHeaderIconSet(data) ? '' :
                        <i className={`fa right5 ${getHeaderIconText(data)}`}></i>
                    }
                    <span>{getHeaderTitleText(data)}</span>
                </h1>
                
                {!getHeaderDescriptionText(data) ? '' :
                    <small>{getHeaderDescriptionText(data)}</small>
                }
                {!shouldShowHeaderPostfixImage() ? '' :
                    <img src={headerPostfixImageUrl()} style={{width: '24px', height: '24px'}} title="RadResponderPrepared" alt="RadResponderPrepared" />
                }
                
                {!shouldShowHeaderPostfixImageChem() ? '' :
                    <img src={headerPostfixImageUrlChem()} style={{width: '24px', height: '24px'}} title="ChemResponderPrepared" alt="ChemResponderPrepared" />
                }

                <small data-bind="favorites: { visible: $parent.displayFavorites($data), idsArray: $parent.getFavoritesIds($data), urlIfFavorite: $parent.favoritesUrl }"></small>
                <div className="pull-right">
                    <div data-part="toolbar">
                        {children}
                    </div>
                </div>
            </div>
            
            {!getHeaderRecordDescriptionText(data) ? '' :
                <div data-part="recordDescription" className="h3 text-muted lighter left5" data-bind="visible: $parent.getHeaderRecordDescriptionText($data), text:$parent.getHeaderRecordDescriptionText($data)"></div>
            }
        </div>
    );
}

export default withRouter(PageHeader);
